<template>
  <div class="recipes-title-bar">
    <div class="title">
      <h1>{{ headingTitle }}</h1>
      <span class="count" v-if="count">{{ count }} Results</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: "RecipesTitleBar",
    computed: {
      ...mapState("recipes", ["count", "filterByCategory"]),
      headingTitle() {
        const categoryName = this.filterByCategory && this.filterByCategory.categoryName;
        return categoryName === "All categories" ? 'Recipes' : categoryName; 
      }
    }
  };
</script>

<style scoped lang="scss">
  .recipes-title-bar {
    background: $color-primary;
    color: $color-white;
    border-top: 1px solid $color-white;

    .title {
      padding: 16px $gutter;
      display: flex;
      align-items: baseline;
    }

    h1, span {
      margin: 0;
      line-height: 1em;
    }

    h1 {
      font-size: 18px;
    }

    span {
      font-size: 14px;
      opacity: 0.5;
      margin-left: 8px;
    }
  }
</style>
